/**
 * Farmville2's iframe.js
 * Farmville 2 game iframe loader.
 * Requires authenticated signed in user.
 * Does Game level auth (like token exchange in zdc or fb context)
 * and loads the frame accordingly.
 * @author Jaiwardhan Swarnakar
 */
import React from 'react'
import BaseComponent from '../../../BaseComponent'
import ServiceLocator from '../../../../ServiceLocator'
import './iframe.css'
import 'bootstrap/dist/js/bootstrap.bundle.min';
import DataStore from '../../../../data/DataStore';
import Rail from './rail/Rail';
//import LoadingWidget from '../../../minions/LoadingWidget';
import Toast from '../../../../util/toasts/Toast';
import LocUtils from '../../../../util/localization/LocUtils';
//import Farm2FacebookConnect from './connect/facebookConnect';
import GenericUtils from '../../../../util/GenericUtils';
import SiteConstants from '../../../../util/SiteConstants';
import $ from "jquery";
import Button from "../../../minions/buttons/Buttons";
import InitFTUE from "../../../minions/permanentBenefit/FTUE/InitFTUE";

class GameFrame extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            ready: false
        }
    }

    render() {
        ServiceLocator.ZTrack.Cast({
            counter: "zdc_2",
            kingdom: "game_load",
            phylum: this.props.accountType,
            genus: ServiceLocator.NetworkManager.Utils.GetSourceFromUrl(),
            value: ServiceLocator.SocialNetworkManager.Me.Identity.getDeviceID()
        });
        return (
            <div id="farm2-game-iframe" className="col hz-align-center game-frame-transition game-iframe-encapsulator">
                <iframe className="embed-responsive-item game-iframe-options"
                    name={JSON.stringify({ "from": "UWG" })}
                    allowFullScreen
                    frameBorder="0"
                    allow="autoplay ; local-network-access *"
                    title="ExampleVille" id="farm2-game-frame"
                    src={this.props.repl}
                    scrolling="no" />
                {/* <img src={process.env.REACT_APP_ASSET_PATH + "/game-banner.png"} className="img-fluid rounded" alt="Farmville 2: Game banner" /> */}
                <img alt=">" id="rail-reviver" src={process.env.REACT_APP_ASSET_PATH + "/arrow-menu.png"} className="arrow-open div-button rounder-corners" hidden={true} onClick={this.props.onRightRailToggle} />
            </div>
        )
    }
}

/**
 * 
 */
class IFrameGame extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            FB: {
                zyAuthHash: "",
                zySig: "",
                zySnid: ""
            },
            ZDC: {
                token: ""
            },
            // ready           : false,
            installCheck: false,
            showConnect: false,
            iframeURL: "",
            canShowFtue: false,
            motdToggle: ""
        }
        // bind handler
        this.onTokenExchangeFailure = this.onTokenExchangeFailure.bind(this);
        this.onTokenExchanged = this.onTokenExchanged.bind(this);
        this.gameFrameColWidth = this.gameFrameColWidth.bind(this);
        this.onRightRailToggle = this.onRightRailToggle.bind(this);
        this.handleFBConnect = this.handleFBConnect.bind(this);
        this.getCookie = this.getCookie.bind(this);
        this.zyngaConnectAuthorization = this.zyngaConnectAuthorization.bind(this);
        this.isViralEndPoint = this.isViralEndPoint.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.showPermBenefitMOTD = this.showPermBenefitMOTD.bind(this);
        this.motdCTAClick = this.motdCTAClick.bind(this);
        this.isNotifEndPoint = this.isNotifEndPoint.bind(this);
    }

    // shouldComponentUpdate(nextProps, nextState) {
    //     // Only update this component if state data is ready
    //     if(
    //         this.state.ready === false &&
    //         nextState.ready === true
    //     ) {
    //         super.log("FARM2 iframejs: Should component updated? : YES:: ", this.state)
    //         return true;
    //     }
    //     super.log("FARM2 iframejs: Should component updated? : NO:: ", this.state)
    //     return false;
    // }
    shouldComponentUpdate() {
        return true;
    }

    onRightRailToggle() {
        // if(this.state.rightRailOn) {
        //     $("#rail-reviver").removeAttr("hidden"); // the reviving arrow
        //     $("#farm2-rail").animate({
        //         'right': '-1000px'
        //     }, 600, 'swing', () => {
        //         $("#farm2-rail").removeClass("col-3").width(0).hide();
        //     })
        // } else {
        //     $("#rail-reviver").attr("hidden", true); // the reviving arrow
        //     $("#farm2-rail").width("100%").animate({
        //         'right': '0px'
        //     }, 400, 'swing', () => {
        //     }).addClass("col-3").show()
        // }

        // this.setState({
        //     rightRailOn: !this.state.rightRailOn
        // })
    }

    gameFrameColWidth() {
        return this.state.rightRailOn ? "9" : "12";
    }

    // Check if its a viral url so we can load different iframe
    isViralEndPoint() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        return (
            window.location.pathname === SiteConstants.UrlCodes.Games.Farm2.VIRAL_URL_PATHNAME &&
            urlParams.get(SiteConstants.UrlCodes.Games.Farm2.VIRAL_URL_QUERY_PARAM)
        );
    }

    isNotifEndPoint() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const notifUrlParam = urlParams.get(SiteConstants.UrlCodes.Games.Farm2.NOTIF_URL_QUERY_PARAM);
        return (
            window.location.pathname.indexOf(SiteConstants.UrlCodes.Games.Farm2.GAME_URL) >= 0 &&
            notifUrlParam != null && notifUrlParam.indexOf('airnotif_P') >= 0
        );
    }

    // Redirect to game url if the url is not proper
    handleRedirect() {
        if (!this.isNotifEndPoint() && !this.isViralEndPoint() && !(window.location.pathname === SiteConstants.UrlCodes.Games.Farm2.GAME_URL)) {
            window.location.href = SiteConstants.UrlCodes.Games.Farm2.GAME_URL;
        }
    }

    /** 
     * Token exchange success, then extract data and
     * set some state.
     */
    onTokenExchanged(data) {
        let storedData;
        var cookie ="" ;
        if (ServiceLocator.Auth.Fb.Is(this.props.context)) {
            storedData = this.state.FB;
            storedData.zyAuthHash = data.zyAuthHash;
            storedData.zySig = data.zySig;
            storedData.zySnid = data.zySnid;
            cookie = this.getCookie("zdc_login_type_new");
            this.setState({
                FB: storedData,
                // ready   : true,
                iframeURL: process.env.REACT_APP_FARM2_GAME_FBURL_PREFIX +
                    "?isOuterIframe=1&fb_locale=en_US&zySnid=1&" +
                    "zyAuthHash=" + storedData.zyAuthHash.trim() + "&" +
                    "zdcLoginType=" + cookie + "&" +
                    "zySig=" + storedData.zySig
            })
            // Store the context and the auth token data within a localstorage
            DataStore.AuthData.Store(data, "FARM2_IFRAME_TOKEN_FB");
            DataStore.AuthData.Store(this.props.context, "FARM2_IFRAME_CONTEXT");
        } else if (ServiceLocator.Auth.Zynga.Is(this.props.context)) {
            storedData = this.state.ZDC;
            storedData.token = data.token;
            storedData.zlivePreference = data.zlivePreference;
            storedData.zlivePreferenceSig = data.zlivePreferenceSig;
            cookie = this.getCookie("zdc_login_type_new");
            let url = "";
            // Load iframe according to url ---> flash.php or viral.php
            if (this.isViralEndPoint()) {
                url = process.env.REACT_APP_FARM2_VIRAL_ENDPOINT +
                    window.location.search +
                    "&zid=" + this.props.data.zid + "&wfnzid=" + this.props.data.zid +
                    "&token=" + storedData.token +  "&zdcLoginType=" + cookie + "&" + GenericUtils.GetURLSearchParams();
            } else {
                url = process.env.REACT_APP_FARM2_GAME_URL_PREFIX +
                    "?zid=" + this.props.data.zid + "&wfnzid=" + this.props.data.zid +
                    "&token=" + storedData.token + "&zdcLoginType=" + cookie +  "&" + GenericUtils.GetURLSearchParams();
            }
            this.setState({
                ZDC: storedData,
                // ready   : true,
                iframeURL: url,
                showConnect: false
            })
            // Store the context and the auth token data within a localstorage
            DataStore.AuthData.Store(data, "FARM2_IFRAME_TOKEN_ZDC");
            DataStore.AuthData.Store(this.props.context, "FARM2_IFRAME_CONTEXT");
        }
    }

    getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    /**
     * Token exchange failure happened.
     * @TODO Maybe throw a toaster and redirect to another page
     * or something.
     */
    onTokenExchangeFailure(err) {
        super.error("Failure to exchange token: ", err);
        Toast.Show({
            message: LocUtils.TPure("toasts.something_went_wrong"),
            severity: Toast.SEVERITY_CODES.ERROR
        })
    }

    /** 
     * Facebook exchange if login context is facebook.
     */
    onTokenSign(data) {
        data = JSON.parse(data);
        var signed_request = data.signed_request;
        ServiceLocator.Auth.Game.FacebookGameRefreshSig(
            signed_request,
            this.onTokenExchanged,
            (err) => { this.onGameAuthorizationFailed(err) }
        )
    }

    /**
     * when token sign failed with fb context
     * @TODO Fire a toaster maybe and redirect to another page 
     */
    onTokenSignFailed(err) {
        super.error("error on token sign fb: ", err);
    }

    /**
     * when Game authorization sig failed in fb context
     * @TODO Fire a toaster maybe and redirect to another page
     */
    onGameAuthorizationFailed(err) {
        super.error("error on token refresh fb: ", err);
    }

    zyngaConnectAuthorization(onComplete) {
        let storedData;
        if (DataStore.AuthData.Fetch("FARM2_IFRAME_TOKEN_ZDC")) {
            storedData = DataStore.AuthData.Fetch("FARM2_IFRAME_TOKEN_ZDC");
            this.setState({
                ZDC: storedData
            })
        } else {
            ServiceLocator.Auth.Game.ZyngaGameExchangeFarm2(
                this.props.data.csrf,
                "118",
                this.onTokenExchanged,
                this.onTokenExchangeFailure
            )
        }
    }

    /**
     * Do all game level authentication in this lifecycle
     * method. Additionally store that in the in memory DataStore
     * storage so that if the user comes to the game page again
     * without a reload/logout, this can be reused.
     */
    componentDidMount() {
        this.handleRedirect();
        let storedData;
        // Do game level authorization here
        if (ServiceLocator.Auth.Fb.Is(this.props.context)) {
            if (DataStore.AuthData.Fetch("FARM2_IFRAME_TOKEN_FB")) {
                storedData = DataStore.AuthData.Fetch("FARM2_IFRAME_TOKEN_FB");
                this.setState({
                    FB: storedData
                })
            } else {
                ServiceLocator.Auth.Game.FacebookGameExchange(
                    this.props.data.accessToken,
                    this.onTokenSign,
                    (err) => { this.onTokenSignFailed(err) }
                )
            }
        } else if (ServiceLocator.Auth.Zynga.Is(this.props.context)) {
            // In ZDC we would want to check if player has played with us before
            // and has installed the game
            console.log("<==> Checking if connected?");
            ServiceLocator.Auth.Zynga.Session.HasInstalled({
                csrf: this.props.data.csrf,
                gname: process.env.REACT_APP_FARM2_GAME_NAME
            }, (resp) => {
                if (true || resp === false) {
                    // Player has already connected, go ahead with game auth
                    console.log("<==> Already connected");
                    this.setState({
                        installCheck: true,
                        showConnect: false
                    }, () => {
                        if (DataStore.AuthData.Fetch("FARM2_IFRAME_TOKEN_ZDC") && DataStore.AuthData.Fetch("FARM2_IFRAME_CONTEXT")) {
                            storedData = DataStore.AuthData.Fetch("FARM2_IFRAME_TOKEN_ZDC");
                            storedData.context = DataStore.AuthData.Fetch("FARM2_IFRAME_CONTEXT");
                            this.setState({
                                ZDC: storedData
                            }, () => {
                                this.onTokenExchanged(storedData);
                            })
                        } else {
                            ServiceLocator.Auth.Game.ZyngaGameExchangeFarm2(
                                this.props.data.csrf,
                                "118",
                                this.onTokenExchanged,
                                this.onTokenExchangeFailure
                            )
                        }
                    })
                } else {
                    // will need to render the connect page
                    console.log("<==> NOT connected");
                    this.setState({
                        installCheck: true,
                        showConnect: true
                    })
                }
            })
        }

        if (this.props.loggedin) {
            this.showPermBenefitMOTD();
        }

        ServiceLocator.ZTrack.Cast({
            counter: "page",
            kingdom: "entry",
            phylum: "farm2"
        })
    }

    showPermBenefitMOTD() {
        if (this.props.featureData.daysPassed === 0 && ServiceLocator.PB.GetMOTDSeenCounter() <= 1) {

            let ftueStep1 = DataStore.LocalStorage.Get("ftue1Step")
            let ftueStep2 = DataStore.LocalStorage.Get("ftue2Step")

            if (ftueStep1 !== null && ftueStep1 !== undefined && ftueStep1 === "1"
                && ftueStep2 !== null && ftueStep2 !== undefined && ftueStep2 === "1") {
                    return;
            }
            this.setState({
                motdToggle: "start"
            })
            ServiceLocator.ZTrack.Cast({
                counter: "zdc_perm_benefit",
                kingdom: 'view',
                phylum: 'start_motd'
            });
            
        } else if (ServiceLocator.PB.FeatureExpired() && this.props.featureData.hasSeenExpiryMotd === false) {
            this.setState({
                motdToggle: "expiry"
            })
            ServiceLocator.ZTrack.Cast({
                counter: "zdc_perm_benefit",
                kingdom: 'feature_complete',
                phylum: this.props.featureData.daysPassed
            });
        }
    }

    handleFBConnect(data) {
        // At this moment we will assumme that if a connect was done
        // or opted out, we want to go ahead with the game load.
        this.zyngaConnectAuthorization();
    }

    motdCTAClick() {
        var method = this.state.motdToggle === "start" ? "startMotd" : "expiryMotd";
        ServiceLocator.PB.UpdateMotdSeen(method);
        ServiceLocator.ZTrack.Cast({
            counter: "zdc_perm_benefit",
            kingdom: "okay",
            phylum: method
        });
        $('#permBenefitModal').modal('hide');
    }

    /**
     * Iframe URLs require different parameters in either contexts
     * i.e. FB or ZDC. Hence our rendering a.w.a. our game level
     * authentication depends on the account context.
     */
    render() {
        // const showLoadingWidget = () => {
        //     return !this.state.installCheck
        //         ? <div className="hz-align-center">
        //             <LoadingWidget show="true" />
        //         </div>
        //         : <div></div>
        // }

        // const showFarm2FacebookConnect = () => {
        //     return (this.state.installCheck && this.state.showConnect)
        //         ? <div>
        //             <Farm2FacebookConnect
        //                 csrf={this.props.data.csrf}
        //                 parentConnectHandle={this.handleFBConnect}
        //             />
        //         </div>
        //         : <div></div>
        // }

        const showGameFrame = () => {
            return (true || (this.state.installCheck && !this.state.showConnect))
                ? <div className="">
                    <div className="row no-gutters">
                        <GameFrame
                            repl={this.state.iframeURL}
                            accountType={this.props.accountType}
                            // ready={this.state.ready}
                            onRightRailToggle={this.onRightRailToggle} />
                        <Rail
                            data={this.props.data}
                            onRightRailToggle={this.onRightRailToggle}
                            zFriends={this.props.zFriends}
                            gameKey="Farm2"
                            gameId={process.env.REACT_APP_FARM2_GAME_ID} />
                    </div>
                </div>
                : <div></div>
        }

        const showMOTD = () => {
            const imgUrl = this.state.motdToggle === "start" ? "ZDC_PermanentBenefits_StartMOTD_final.png" : "ZDC_PermanentBenefits_ExpiryMOTD_final.png";
            return (true) ?
                <div className="modal fade" id="permBenefitModal" data-keyboard="false" data-backdrop="static" tabIndex="1" role="dialog" aria-labelledby="permBenefitModal" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                        <div className="modal-content" style={{ border: "none" }}>
                            <div className="modal-body modal-body-mod">
                                <div className="bg-text"
                                    style={{ backgroundPositionY: 'bottom', backgroundImage: " url('" + process.env.REACT_APP_ASSET_PATH + "/dialogs/permanentBenefits/ui_frame.png')" }}>
                                    <div className="row no-gutters" style={{ backgroundColor: "#222C37" }}>
                                        <div className="col " style={{ alignItems: "center", display: "flex" }}>
                                            <img alt="zynga" className="header-zy-logo"
                                                src={process.env.REACT_APP_ASSET_PATH + "/zynga-logo-off.png"} />
                                            <div className="rdr-header-text">
                                                {this.state.motdToggle === "start" ? LocUtils.T("feature.dialog.start.header") : LocUtils.T("feature.dialog.expiry.header")}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row bottom-messaging">
                                        <div className="col-1"></div>
                                        <div className="col" style={{ lineHeight: "1.4rem" }}>
                                            <span className="rdr-bottom-text align-middle">
                                                {this.state.motdToggle === "start" ? LocUtils.T("feature.dialog.start.subheader") : LocUtils.T("feature.dialog.expiry.subheader")}
                                            </span>
                                        </div>
                                        <div className="col-1"></div>
                                    </div>
                                    <div className="row no-gutters">
                                        <div className="col">
                                            <img alt="airZDCBenefits" className="dialog-img"
                                                src={process.env.REACT_APP_ASSET_PATH + "/dialogs/permanentBenefits/" + imgUrl} />
                                        </div>
                                    </div>
                                    <div className="row bottom-messaging">
                                        <div className="col-3"></div>
                                        <div className="col-6"
                                            style={{ lineHeight: "1.6rem" }}>
                                            <Button
                                                forceClass={"btn button-green btn-lg button-green-text vl-b motd-btn " + (this.state.motdToggle === "start" ? "animation-glowing-btn" : "")}
                                                message={this.state.motdToggle === "start" ? LocUtils.T("feature.dialog.start.cta") : LocUtils.T("feature.dialog.expiry.cta")}
                                                onClick={() => {
                                                    this.motdCTAClick();
                                                    if (this.state.motdToggle === "start") {
                                                        this.setState({
                                                            canShowFtue: true
                                                        })

                                                        ServiceLocator.ZTrack.Cast({
                                                            counter: "zdc_perm_benefit",
                                                            kingdom: 'ftue_start'
                                                        });
                                                    }
                                                }}
                                            />
                                        </div>
                                        <div className="col-3"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                : <div></div>
        }

        return (
            <div>
                {/* <div style={{backgroundColor: '#008080', width: '100%'}}> */}
                <div className="row game-iframe-row no-gutters">
                    <div className="col-12">
                        {/* While we are checking connection status, lets show this widget */}
                        {/* {showLoadingWidget()} */}

                        {/* Show a connect dialog in this case */}
                        {/* {showFarm2FacebookConnect()} */}

                        {/* Load the game if everything is already ready */}
                        {this.state.motdToggle !== "" && showMOTD()}
                        {showGameFrame()}

                        {this.state.canShowFtue &&
                            <InitFTUE
                                firstName={this.props.data.userAttr.firstName} />
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default IFrameGame;